export const DateFormat = {
  SHORT_ISO: 'yyyy-MM-dd',
  LEGACY_MOMENT_SHORT_ISO: 'YYYY-MM-DD',
};
